"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualificationExperience = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_entity_1 = require("./contact.entity");
let QualificationExperience = class QualificationExperience {
    constructor(createdAt, updatedAt, createdBy, updatedBy, contact) {
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.contact = contact;
    }
};
exports.QualificationExperience = QualificationExperience;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], QualificationExperience.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "name_of_qualification",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], QualificationExperience.prototype, "nameOfQualification", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "year_of_qualification",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], QualificationExperience.prototype, "yearOfQualification", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "details",
        type: "text",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], QualificationExperience.prototype, "details", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "university_name",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], QualificationExperience.prototype, "universityName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], QualificationExperience.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], QualificationExperience.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], QualificationExperience.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], QualificationExperience.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], QualificationExperience.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.qualificationExperiences, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], QualificationExperience.prototype, "contact", void 0);
exports.QualificationExperience = QualificationExperience = tslib_1.__decorate([
    (0, typeorm_1.Entity)("qualification_experience"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number, Object])
], QualificationExperience);
